import React, { useEffect, useState } from 'react';
import { Box, Button, IconButton, Modal, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AppDispatch, RootState } from '../../store/store';
import { useSelector } from 'react-redux';
import Client from '../../interfaces/client';
import { loadClients } from '../../store/slices/clientSlice';
import { useAppDispatch } from '../../store/hooks';
import SearchResultGrid from '../searchResultGrid/searchResultGrid';
import modalStyle from '../../styles/modalStyle';
import apiClient from '../../axiosClient';
import clientColumnDef from '../../colDef/clientColumnDef';
import { textPattern, textWithoutSpacePattern } from '../../constants/patterns';
import DropDown from '../baseComponents/dropdown';

const ManageClient = () => {
    const [openModal, setOpenModal] = useState(false);
    const [name, setName] = useState<string>('');
    const [clientName, setClientName] = useState<string>();
    const [clientAddress, setClientAddress] = useState<string>();
    const [clientContact, setClientContact] = useState<string>();
    const [clientPdbId, setClientPdbId] = useState<string>("");
    const [pdbIdsList, setPdbIdsList] = useState<string[]>([]);

    const dispatch: AppDispatch = useAppDispatch();

    let clients: Client[] = useSelector((state: RootState) => state.clients.clients);

    // Handle modal open/close
    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => {
        setName('');
        setClientName(undefined);
        setClientContact(undefined);
        setClientAddress(undefined);
        setOpenModal(false);
        setClientPdbId("");
    };

    // Handle form submission
    const handleSubmit = async () => {
        try {

            if (!clientName || !clientContact || !clientAddress || !name || !clientPdbId)  {
                alert('Please fill all required values');
                return;
            }
            // Make POST request to add new client (use your real API endpoint)
            const response = await apiClient.post('/api/v1/client',
                {
                    name,
                    'client_name': clientName,
                    'client_address': clientAddress,
                    'client_contact': clientContact,
                    'pdb_id': clientPdbId
                }
            );
            if (response.status === 200) {
                clients = [...clients, response.data as Client];
                dispatch(loadClients(clients));
                handleCloseModal(); // Close the modal on success
                alert('Success: Client created successfully');
            } else {
                alert('Error: Could not create client');
            }
        } catch (error: any) {
            if (error.response) {
                alert('Error response data:' + error.response.data.message);
            } else if (error.request) {
                alert('No response received:' + error.request);
            } else {
                alert('Error message:' + error.message);
            }
        }
    };

    const fetchPdbIds = async () => {
        try {
            const response = await apiClient.get('/api/v1/pdb');
            if (response.status === 200) {
                setPdbIdsList(response.data);
            }
        } catch (error: any) {
            alert('Error: Could not fetch PDB Ids list');
            console.error(error);
        }
    };

    useEffect(() => {
      fetchPdbIds();
    }, [])
    

    return (
        <Box m={2}>
            <Box display="flex" justifyContent="flex-end" marginY="10px">
                <Button variant="contained" onClick={handleOpenModal}>
                    Add New Client
                </Button>
            </Box>

            <SearchResultGrid
                height='80vh'
                getRowId={(row: Client) => row.client_name}
                results={clients}
                onSelectRow={() => { }}
                columns={clientColumnDef}
            />

            {/* Modal for adding a new client */}
            <Modal open={openModal} onClose={handleCloseModal}>
                <Box sx={modalStyle}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography id="modal-title" variant="h6">
                        Add New Client
                        </Typography>
                        <IconButton onClick={handleCloseModal}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <TextField
                        label="Client Name"
                        name="client name"
                        value={clientName}
                        onChange={(event) => setClientName(event?.target.value.replace(textWithoutSpacePattern, ""))}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <TextField
                        label="Name"
                        name="name"
                        value={name}
                        onChange={(event) => setName(event?.target.value.replace(textPattern, ""))}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <TextField
                        label="Client Address"
                        name="address"
                        value={clientAddress}
                        onChange={(event) => setClientAddress(event?.target.value.replace(textPattern, ""))}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <TextField
                        label="Client Contact"
                        name="contact"
                        value={clientContact}
                        onChange={(event) => setClientContact(event?.target.value.replace(textPattern, ""))}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <DropDown
                        label="Select PDB Id"
                        items={pdbIdsList}
                        selectedValue={clientPdbId}
                        onSelection={(value) => setClientPdbId(String(value ?? "").replace(textPattern, ""))}
                    />
                    <Box mt={2} textAlign="right">
                        <Button variant="contained" color="primary" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};

export default ManageClient;
